export const THUNDERSTORM_SEVERITY_ORDER = ["decaying", "unclassified", "low", "mid", "high"] as const;
export type ThunderstormSeverity = (typeof THUNDERSTORM_SEVERITY_ORDER)[number];

export const THUNDERSTORM_TYPE_ORDER = ["history", "current", "nowcast"] as const;
export type ThunderstormType = (typeof THUNDERSTORM_TYPE_ORDER)[number];
